import React from "react";

//import stock
import stock from "../img/image1.jpg";
import stock1 from "../img/image2.jpg";
import stock2 from "../img/image3.jpg";
import stock3 from "../img/image4.jpg";
import stock4 from "../img/image5.jpg";
import stock5 from "../img/image6.jpg";

import project1 from "../img/projects/1.png";
import project2 from "../img/projects/2.png";
import project3 from "../img/projects/3.png";
import project4 from "../img/projects/4.png";
import project5 from "../img/projects/5.png";
import project6 from "../img/projects/6.png";
import project7 from "../img/projects/7.jpg";

import E1 from "../img/projects/E1.jpeg";
import E2 from "../img/projects/E2.jpeg";
import E3 from "../img/projects/E3.jpeg";
import E4 from "../img/projects/E4.jpeg";
import E5 from "../img/projects/E5.jpeg";
import E6 from "../img/projects/E6.jpeg";
import E7 from "../img/projects/E7.jpeg";
import E8 from "../img/projects/E8.jpeg";
import E9 from "../img/projects/E9.jpeg";
import E10 from "../img/projects/E10.jpeg";
import E11 from "../img/projects/E11.jpg";
import E12 from "../img/projects/E12.jpg";
import E13 from "../img/projects/E13.jpg";
import E14 from "../img/projects/E14.jpg";
import E15 from "../img/projects/E16.jpg";
import E16 from "../img/projects/E15.jpg";
import E17 from "../img/projects/E17.jpg";
import E18 from "../img/projects/E18.jpg";
import E19 from "../img/projects/E19.jpg";

import R1 from "../img/projects/R1.jpg";
import R2 from "../img/projects/R2.jpg";
import R3 from "../img/projects/R3.jpg";
import R4 from "../img/projects/R4.jpg";
import R5 from "../img/projects/R5.jpg";
import R6 from "../img/projects/R6.jpg";
import R7 from "../img/projects/R7.jpg";
import R8 from "../img/projects/R8.jpg";
import R9 from "../img/projects/R9.jpg";
import R10 from "../img/projects/R10.jpg";
import R11 from "../img/projects/R11.jpg";
import R12 from "../img/projects/R12.jpg";

import B1 from "../img/projects/B1.jpg";
import B2 from "../img/projects/B2.jpg";
import B3 from "../img/projects/B3.jpg";
import B4 from "../img/projects/B4.jpg";
import B5 from "../img/projects/B5.jpg";
import B6 from "../img/projects/B6.jpg";
import B7 from "../img/projects/B7.jpg";
import B8 from "../img/projects/B8.jpg";
import B9 from "../img/projects/B9.jpg";
import B10 from "../img/projects/B10.jpg";
import B11 from "../img/projects/B11.jpg";
import B12 from "../img/projects/B12.jpg";

import T1 from "../img/projects/T1.jpg";
import T2 from "../img/projects/T2.jpg";
import T3 from "../img/projects/T3.jpg";
import T4 from "../img/projects/T4.jpg";
import T5 from "../img/projects/T5.jpg";
import T6 from "../img/projects/T6.jpg";
import T7 from "../img/projects/T7.jpg";
import T8 from "../img/projects/T8.jpg";
import T9 from "../img/projects/T9.jpg";
import T10 from "../img/projects/T10.jpg";
import T11 from "../img/projects/T11.jpg";
import T12 from "../img/projects/T12.jpg";
import T13 from "../img/projects/T13.jpg";

import Z1 from "../img/projects/Z1.jpg";
import Z2 from "../img/projects/Z2.jpg";
import Z3 from "../img/projects/Z3.jpg";
import Z4 from "../img/projects/Z4.jpg";
import Z5 from "../img/projects/Z5.jpg";
import Z6 from "../img/projects/Z6.jpg";
import Z7 from "../img/projects/Z7.jpg";
import Z8 from "../img/projects/Z8.jpg";
import Z9 from "../img/projects/Z9.jpg";
import Z10 from "../img/projects/Z10.jpg";
import Z11 from "../img/projects/Z11.jpg";
import Z12 from "../img/projects/Z12.jpg";

class Portfolio extends React.Component {
  render() {
    return (
      <section id="work" className="portfolio-mf sect-pt4 route">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="title-box text-center">
                <h3 className="title-a">Portfolio</h3>
                <p className="subtitle-a">
                  Exploring the world, one project at a time: A portfolio of my creative endeavors
                </p>
                <div className="line-mf"></div>
              </div>
            </div>
          </div>
          <div className="row">
          <div className="col-md-4">
              <div className="work-box">
                <a href={T1} data-lightbox="gallery-medlingos">
                  <div className="work-img">
                    <img src={T11} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-12">
                        <h2 className="w-title">Tenant App</h2>
                        <div className="w-more">
                          <span className="w-paragraph">
                            Tenant mobile app is a powerful tool that helps tenants manage their rental properties with ease. With Tenant, tenants can pay rent, request repairs, communicate with landlords, and view lease information, all from the convenience of their smartphones.
                          </span>
                        </div>
                      </div>
                      {/* <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </a>
                <a
                  href={T2}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={T3}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={T4}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={T5}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={T6}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={T7}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={T8}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={T9}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={T10}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={T11}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={T12}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={T13}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={Z1} data-lightbox="gallery-mf">
                  <div className="work-img">
                    <img src={Z5} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-12">
                        <h2 className="w-title">Zstar</h2>
                        <div className="w-more">
                          <span className="w-paragraph">
                          ZStar is a cutting-edge mobile application that streamlines ERP processes on-the-go. With its intuitive user interface and robust features, ZStar enables users to access critical business data and execute tasks from anywhere, at any time.                          </span>
                        </div>
                      </div>
                      {/* <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </a>
                <a
                  href={Z2}
                  data-lightbox="gallery-mf"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={Z3}
                  data-lightbox="gallery-mf"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={Z4}
                  data-lightbox="gallery-mf"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={Z11}
                  data-lightbox="gallery-mf"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={Z5}
                  data-lightbox="gallery-mf"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={Z6}
                  data-lightbox="gallery-mf"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={Z7}
                  data-lightbox="gallery-mf"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={Z8}
                  data-lightbox="gallery-mf"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={Z9}
                  data-lightbox="gallery-mf"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={Z10}
                  data-lightbox="gallery-mf"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={Z12}
                  data-lightbox="gallery-mf"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={E1} data-lightbox="gallery-aguadeluz">
                  <div className="work-img">
                    <img src={E9} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-12">
                        <h2 className="w-title">Ashh Karo</h2>
                        <div className="w-more">
                          <span className="w-paragraph">
                          Ashh Karo is an innovative ecommerce mobile app that offers a seamless shopping experience to its users. With a user-friendly interface and an extensive collection of products, Ashh Karo is a one-stop destination for all your shopping needs. 
                          </span>{" "}
                        </div>
                      </div>
                      {/* <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </a>
                <a
                  href={E2}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={E3}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={E4}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={E5}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={E6}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={E7}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={E8}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={E9}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={E10}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={E11}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={E12}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={E13}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={E14}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={E15}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={E16}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={E17}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={E18}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={E19}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={R1} data-lightbox="gallery-todo">
                  <div className="work-img">
                    <img src={R4} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-12">
                        <h2 className="w-title">Restaurant</h2>
                        <div className="w-more">
                          <span className="w-paragraph">
                          Introducing "Restaurant" - the ultimate food delivery app for all your culinary cravings! With a vast selection of restaurants and cuisines to choose from, you can satisfy your hunger pangs with just a few taps on your mobile phone.
                          </span>
                          {/*} / <span className="w-date">18 Sep. 2018</span>*/}
                        </div>
                      </div>
                      {/* <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </a>
                <a
                  href={R2}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={R3}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={R6}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={R4}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={R5}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={R7}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={R8}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={R9}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={R10}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={R11}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={R12}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={B1} data-lightbox="gallery-smth">
                  <div className="work-img">
                    <img src={B3} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-12">
                        <h2 className="w-title">Executive Cutts</h2>
                        <div className="w-more">
                          <span className="w-paragraph">
                            Executive Cutts is a must-have mobile app for all grooming enthusiasts who seek convenience and quality service. With just a few taps, users can book appointments, select preferred barbers, and customize their haircuts to suit their style.
                          </span>
                        </div>
                      </div>
                      {/* <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </a>
                <a
                  href={B2}
                  data-lightbox="gallery-smth"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={B3}
                  data-lightbox="gallery-smth"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={B4}
                  data-lightbox="gallery-smth"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={B5}
                  data-lightbox="gallery-smth"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={B6}
                  data-lightbox="gallery-smth"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={B7}
                  data-lightbox="gallery-smth"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={B8}
                  data-lightbox="gallery-smth"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={B9}
                  data-lightbox="gallery-smth"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={B10}
                  data-lightbox="gallery-smth"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={B11}
                  data-lightbox="gallery-smth"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={B12}
                  data-lightbox="gallery-smth"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={project4} data-lightbox="gallery-vmarine">
                  <div className="work-img">
                    <img src={project4} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-12">
                        <h2 className="w-title">DD Graphics</h2>
                        <div className="w-more">
                          <span className="w-paragraph">
                            DD Graphics & Branding is an innovative mobile app that allows businesses to create stunning logos effortlessly. Whether you're starting a new business or rebranding an existing one, DD Graphics & Branding is the perfect tool to help you elevate your brand's identity.
                          </span>
                        </div>
                      </div>
                      {/* <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </a>
                <a
                  href={project1}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={project2}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={project3}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={project4}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={project5}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={project6}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={project7}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Portfolio;
